import React from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { Place } from 'react-tooltip';
import Tooltip from './Tooltip';

interface Props {
  id: string;
  message: string;
  position?: Place;
}

const InfoTooltip = ({ id, message, position = 'right' }: Props) => (
  <>
    <Tooltip place={position} effect="solid" id={id} message={message} />

    <div className="flex items-center" data-tip data-for={id}>
      <MdInfoOutline size={16} className="ml-1 text-gray-600" />
    </div>
  </>
);

export default InfoTooltip;
